import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-address',
  styleUrl: 'address.css',
  shadow: true,
})
export class Address {
  @Prop() addressType: string = "Campus Location";
  @Prop() campusLocationName: string = "Buidling/Hall Name";
  @Prop() streetInfo: string = "10900 Euclid Ave.";
  @Prop() cityStateZip: string = "Cleveland, OH 44106";

  render() {
    return (
      <div class="address-full">
        <address>
          <p class="campus-location"><strong>{this.addressType}:</strong></p>
          <p>{this.campusLocationName}</p>
          <p>{this.streetInfo}</p>
          <p>{this.cityStateZip}</p>
        </address>
      </div>
    );
  }
}
